import { Directive, ElementRef,  Input, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { BaseAttribute } from './baseAttribute';

@Directive({
    selector: '[update]'
})
export class UpdateDirective extends BaseAttribute  implements OnInit {

      constructor(private el: ElementRef,private translate: TranslateService ) { super(); }

      @Input('if')        generalIf: any;

      @Input('html-if')   htmlWhere: any;
      
      @Input('param')     param: any;

      private _html:string;

      get insert() {
              return this._html;
      }

      @Input ("update")  set update(theValue:string) {

              if ( !theValue ) return;
              this._html = super.ifCheck(theValue, this.htmlWhere, this.generalIf );
              this.el.nativeElement.innerHTML = this.translate.instant(this._html,this.param);
      }


      ngOnInit(): void {

            this.translate.onLangChange.subscribe((event: Event) => {
                  if ( !this._html ) return;
                  this.el.nativeElement.innerHTML = this.translate.instant(this._html,this.param);
            });
      }
}
